export const POPULAR_COMPANIES = [
  {
    id: 1,
    name: 'Apple Inc.'
  },
  {
    id: 2,
    name: 'Microsoft Corporation'
  },
  {
    id: 3,
    name: 'Amazon.com Inc.'
  },
  {
    id: 4,
    name: 'Alphabet Inc.'
  },
  {
    id: 5,
    name: 'Meta Platforms Inc.'
  },
  {
    id: 6,
    name: 'NVIDIA Corporation'
  },
  {
    id: 7,
    name: 'Tesla Inc.'
  },
  {
    id: 8,
    name: 'Berkshire Hathaway Inc.'
  },
  {
    id: 9,
    name: 'UnitedHealth Group Inc.'
  },
  {
    id: 10,
    name: 'JPMorgan Chase & Co.'
  },
  {
    id: 11,
    name: 'Johnson & Johnson'
  },
  {
    id: 12,
    name: 'Visa Inc.'
  },
  {
    id: 13,
    name: 'Procter & Gamble Company'
  },
  {
    id: 14,
    name: 'Mastercard Inc.'
  },
  {
    id: 15,
    name: 'Home Depot Inc.'
  },
  {
    id: 16,
    name: 'Bank of America Corp.'
  },
  {
    id: 17,
    name: 'Chevron Corporation'
  },
  {
    id: 18,
    name: 'Pfizer Inc.'
  },
  {
    id: 19,
    name: 'Coca-Cola Company'
  },
  {
    id: 20,
    name: 'PepsiCo Inc.'
  },
  {
    id: 21,
    name: 'Netflix Inc.'
  },
  {
    id: 22,
    name: 'Adobe Inc.'
  },
  {
    id: 23,
    name: 'Cisco Systems Inc.'
  },
  {
    id: 24,
    name: 'Walmart Inc.'
  },
  {
    id: 25,
    name: 'McDonald\'s Corporation'
  },
  {
    id: 26,
    name: 'Nike Inc.'
  },
  {
    id: 27,
    name: 'Starbucks Corporation'
  },
  {
    id: 28,
    name: 'Target Corporation'
  },
  {
    id: 29,
    name: 'Disney Company'
  },
  {
    id: 30,
    name: 'PayPal Holdings Inc.'
  },
  {
    id: 31,
    name: 'Costco Wholesale Corporation'
  },
  {
    id: 32,
    name: 'Intel Corporation'
  },
  {
    id: 33,
    name: 'Verizon Communications Inc.'
  },
  {
    id: 34,
    name: 'AT&T Inc.'
  },
  {
    id: 35,
    name: 'T-Mobile US Inc.'
  },
  {
    id: 36,
    name: 'Uber Technologies Inc.'
  },
  {
    id: 37,
    name: 'Airbnb Inc.'
  },
  {
    id: 38,
    name: 'DoorDash Inc.'
  },
  {
    id: 39,
    name: 'Spotify Technology SA'
  },
  {
    id: 40,
    name: 'Snap Inc.'
  },
  {
    id: 41,
    name: 'Twitter Inc.'
  },
  {
    id: 42,
    name: 'Pinterest Inc.'
  },
  {
    id: 43,
    name: 'Roku Inc.'
  },
  {
    id: 44,
    name: 'Zoom Video Communications Inc.'
  },
  {
    id: 45,
    name: 'Shopify Inc.'
  },
  {
    id: 46,
    name: 'Square Inc.'
  },
  {
    id: 47,
    name: 'Robinhood Markets Inc.'
  },
  {
    id: 48,
    name: 'Coinbase Global Inc.'
  },
  {
    id: 49,
    name: 'Dell Technologies Inc.'
  },
  {
    id: 50,
    name: 'HP Inc.'
  },
  {
    id: 51,
    name: 'Sony Group Corporation'
  },
  {
    id: 52,
    name: 'Nintendo Co. Ltd.'
  },
  {
    id: 53,
    name: 'Electronic Arts Inc.'
  },
  {
    id: 54,
    name: 'Activision Blizzard Inc.'
  },
  {
    id: 55,
    name: 'Lyft Inc.'
  },
  {
    id: 56,
    name: 'Instacart Inc.'
  },
  {
    id: 57,
    name: 'Slack Technologies Inc.'
  },
  {
    id: 58,
    name: 'Dropbox Inc.'
  },
  {
    id: 59,
    name: 'DocuSign Inc.'
  },
  {
    id: 60,
    name: 'Twilio Inc.'
  },
  {
    id: 61,
    name: 'Best Buy Co. Inc.'
  },
  {
    id: 62,
    name: 'Lowe\'s Companies Inc.'
  },
  {
    id: 63,
    name: 'eBay Inc.'
  },
  {
    id: 64,
    name: 'Etsy Inc.'
  },
  {
    id: 65,
    name: 'Wayfair Inc.'
  },
  {
    id: 66,
    name: 'Chewy Inc.'
  },
  {
    id: 67,
    name: 'Peloton Interactive Inc.'
  },
  {
    id: 68,
    name: 'Grubhub Inc.'
  },
  {
    id: 69,
    name: 'Yelp Inc.'
  },
  {
    id: 70,
    name: 'TripAdvisor Inc.'
  },
  {
    id: 71,
    name: 'Warner Bros. Discovery Inc.'
  },
  {
    id: 72,
    name: 'Paramount Global'
  },
  {
    id: 73,
    name: 'Fox Corporation'
  },
  {
    id: 74,
    name: 'Comcast Corporation'
  },
  {
    id: 75,
    name: 'Spotify Technology SA'
  },
  {
    id: 76,
    name: 'American Express Company'
  },
  {
    id: 77,
    name: 'Capital One Financial Corp.'
  },
  {
    id: 78,
    name: 'Morgan Stanley'
  },
  {
    id: 79,
    name: 'Goldman Sachs Group Inc.'
  },
  {
    id: 80,
    name: 'Charles Schwab Corporation'
  },
  {
    id: 81,
    name: 'Unilever PLC'
  },
  {
    id: 82,
    name: 'Colgate-Palmolive Company'
  },
  {
    id: 83,
    name: 'Kimberly-Clark Corporation'
  },
  {
    id: 84,
    name: 'General Mills Inc.'
  },
  {
    id: 85,
    name: 'Kraft Heinz Company'
  },
  {
    id: 86,
    name: 'Ford Motor Company'
  },
  {
    id: 87,
    name: 'General Motors Company'
  },
  {
    id: 88,
    name: 'Toyota Motor Corporation'
  },
  {
    id: 89,
    name: 'Honda Motor Co. Ltd.'
  },
  {
    id: 90,
    name: 'BMW Group'
  },
  {
    id: 91,
    name: 'Marriott International Inc.'
  },
  {
    id: 92,
    name: 'Hilton Worldwide Holdings Inc.'
  },
  {
    id: 93,
    name: 'Booking Holdings Inc.'
  },
  {
    id: 94,
    name: 'Expedia Group Inc.'
  },
  {
    id: 95,
    name: 'Southwest Airlines Co.'
  },
  {
    id: 96,
    name: 'Deutsche Telekom AG'
  },
  {
    id: 97,
    name: 'Vodafone Group PLC'
  },
  {
    id: 98,
    name: 'SoftBank Group Corp.'
  },
  {
    id: 99,
    name: 'KDDI Corporation'
  },
  {
    id: 100,
    name: 'America Movil SAB de CV'
  }
];

// Initialize localCompanies from localStorage or fall back to POPULAR_COMPANIES
let localCompanies = JSON.parse(localStorage.getItem('companies')) || [...POPULAR_COMPANIES];

// Update addCompanyToList to persist to localStorage
export const addCompanyToList = (company) => {
  // Generate next ID
  const nextId = Math.max(...localCompanies.map(c => c.id)) + 1;
  
  // Create new company with consistent format
  const newCompany = {
    id: nextId,
    name: company.name
  };

  // Avoid duplicates
  if (!localCompanies.some(c => c.name.toLowerCase() === company.name.toLowerCase())) {
    localCompanies.unshift(newCompany);
    // Save to localStorage
    localStorage.setItem('companies', JSON.stringify(localCompanies));
  }
};

// Keep the existing search function
export const searchCompanyList = (query) => {
  const searchTerms = query.toLowerCase().split(' ');
  
  return localCompanies.filter(company => {
    const companyNameWords = company.name.toLowerCase().split(/[\s.,]+/);
    return searchTerms.every(term => 
      companyNameWords.some(word => word.includes(term))
    );
  });
};

export const getInitialCompanies = () => {
  return localCompanies.slice(0, 3);
};
  